import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from './Form';

class Edit extends Component {
  render() {
    const {
      modalType,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
      globalExpiredVraSettings,
    } = this.props;

    return (
      <Form
        modalType={modalType}
        onCloseHandler={onCloseHandler}
        onSubmitHandler={onSubmitHandler}
        error={error}
        submitting={submitting}
        globalExpiredVraSettings={globalExpiredVraSettings}
      />
    );
  }
}

Edit.propTypes = {
  modalType: PropTypes.string.isRequired,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  globalExpiredVraSettings: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    gracePeriod: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    exceptionReason: PropTypes.string,
  }).isRequired,
};

Edit.defaultProps = {
  error: null,
  submitting: false,
};

export default Edit;
